import { Link } from "react-router-dom";
// import { getKommuneByKommuneKode } from "../../../../util/kommune";
import {
  extractCurrentPersonArt,
  extractCurrentPersonFirma,
} from "../../../../util/person";
import ListItem from "../../../ListItem";
import { SidebarContainer } from "../../../SidebarContainer";
import { PersonDto } from "../../../../interfaces/schema";
import { defaultIfNullish } from "../../../../util/stringUtil";

export default function Sidebar(props: { person: PersonDto }) {
  const { person } = props;
  const { kundeNr, erUdoevende } = person;
  const currentPersonArt = extractCurrentPersonArt(person);
  const currentFirma = extractCurrentPersonFirma(person);
  return (
    <SidebarContainer>
      <ListItem
        label="Firma"
        value={
          <>
            {currentFirma && (
              <Link
                className="link-primary"
                to={`/firma/${currentFirma.firma.id}`}
              >
                {currentFirma.firma.navn1}
              </Link>
            )}
            {!currentFirma && "Intet nuværende firma"}
          </>
        }
      />
      <ListItem label="Kundenummer" value={kundeNr} />
      <ListItem label="Udøvende" value={erUdoevende ? "Ja" : "Nej"} />
      <ListItem
        label="Personart"
        value={currentPersonArt?.personartNrNavigation?.navn}
      />
      <ListItem
        label="By"
        value={defaultIfNullish(person.adresse?.adresse.bynavn)}
      />
    </SidebarContainer>
  );
}
